import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonService } from '../shared-resources/services/common.service';
import { SessionTimerService } from './services/session-timer.service';

@Component({
  selector: 'app-session-expiration-alert',
  templateUrl: './session-expiration-alert.component.html',
})
export class SessionExpirationAlertComponent implements OnInit {

  private sessionTimerSubscription!: Subscription;
  public displayModal: boolean = false;
  assetsUrl = '';
  alertAt: number = Number(environment.delegateSessionTimeoutAlertBefore);
  
  constructor(
    public sessionTimer: SessionTimerService,
    public commonService: CommonService
  ) {
    //blank constructor
  }

  ngOnInit() {
    console.log("Alert at - " + this.alertAt);
    this.assetsUrl = environment.assetsUrl;
    this.commonService.subscribeSessionTimer((flag: boolean) => {
      if (!this.sessionTimerSubscription && flag) {
        this.trackSessionTime();
      }
    })    
  }

  private trackSessionTime() {
    this.sessionTimer.startTimer();
    this.sessionTimerSubscription = this.sessionTimer.remainSeconds$.subscribe(
      (t) => {
        console.log("Remaining secs - " + t);
        if (t === this.alertAt) {
          this.open();
        }
        if (t === 0) {
          this.cleanUp();
        }        
      }
    );
  }

  onContinue() {
    this.sessionTimer.startTimer();  
    this.close();  
  }

  onLogout() {
    this.sessionTimer.stopTimer();
    sessionStorage.removeItem('delegateLogin');
    this.commonService.setDelegateTokenInfo(null); 
    this.close();
    window.location.href = environment.delegateLogoutUrl;
  }

  open(): void {
    this.displayModal = true;      
  }

  close(): void {
    this.displayModal = false;
  }

  cleanUp() {
    this.sessionTimer.stopTimer();
    sessionStorage.removeItem('delegateLogin');
    this.commonService.setDelegateTokenInfo(null); 
    this.close();
    if (this.sessionTimerSubscription) {
      this.sessionTimerSubscription.unsubscribe();
      window.location.href = environment.delegateSessionOverRedirectUrl;
    }    
  }

  ngOnDestroy(): void {
    this.cleanUp();
  }  

  toHoursMinutesSeconds(totalSeconds: any) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    let result = `${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    if (!!hours) {
      result = `${hours.toString()}:${minutes
        .toString()
        .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return result;
  }
}
